import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

type SettingsPanelCardProps = {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  iconWrapperClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
};

export function SettingsPanelCard({
  icon: Icon,
  title,
  description,
  action,
  children,
  className,
  iconWrapperClassName,
  titleClassName,
  descriptionClassName,
}: SettingsPanelCardProps) {
  return (
    <Card className={cn("shadow-sm", className)}>
      <CardHeader className="flex flex-row items-start justify-between gap-3 border-b px-6 py-4">
        <div className="flex items-start gap-3">
          <div
            className={cn(
              "flex h-10 w-10 shrink-0 items-center justify-center rounded-[9px] bg-violet-100 dark:bg-violet-900/30",
              iconWrapperClassName
            )}
          >
            <Icon className="size-5 text-primary" />
          </div>
          <div>
            <CardTitle className={cn("text-sm font-semibold", titleClassName)}>
              {title}
            </CardTitle>
            <CardDescription className={descriptionClassName}>
              {description}
            </CardDescription>
          </div>
        </div>
        {action}
      </CardHeader>
      <CardContent className="space-y-6 p-6">{children}</CardContent>
    </Card>
  );
}
